var _defs, _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesSecurityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-security-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-security-icon_svg__cls-1,.websites-security-icon_svg__cls-2{fill:#e84b0f;stroke:#010101;stroke-miterlimit:10;stroke-width:2px}.websites-security-icon_svg__cls-2{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.65 38.44c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-security-icon_svg__cls-1",
    d: "M53.89 12.45c-13.27 3.28-23.17-3.73-23.17-3.73s-9.9 7.01-23.17 3.73c-5.71 5.74-2.67 38.99 23.17 48.7 25.84-9.72 28.88-42.96 23.17-48.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "websites-security-icon_svg__cls-2",
    d: "M30.72 56.66C16.05 50.74 11.53 36.59 10.25 30.7c-1.46-6.68-.88-11.75.12-13.94 1.82.36 3.7.52 5.56.52 7.04 0 12.42-2.52 14.79-3.86 2.34 1.34 7.71 3.86 14.79 3.86 1.85 0 3.7-.18 5.56-.52 1 2.22 1.58 7.26.12 13.94-1.28 5.89-5.8 20.04-20.47 25.96z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "websites-security-icon_svg__cls-2",
    d: "M30.72 24.5c3.13 0 5.65 2.52 5.65 5.65v7.74h-11.3v-7.74c0-3.1 2.52-5.65 5.65-5.65z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "websites-security-icon_svg__cls-1",
    d: "M24.13 33.4h13.15c.52 0 .91.39.91.91v10.11c0 .52-.39.91-.91.91H24.13c-.52 0-.91-.39-.91-.91V34.31c0-.52.43-.91.91-.91z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "websites-security-icon_svg__cls-2",
    cx: 30.72,
    cy: 39.35,
    r: 0.97
  })));
}
export default SvgWebsitesSecurityIcon;